<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-briefcase-clock" 
        v-bind:show.sync="dialog"
        maxWidth="50%"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="7">
                            <s-text-field autofocus :error-messages="errors.name" v-model="model.name" label="Nome*" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <s-text-field :error-messages="errors.initials" v-model="model.initials" label="Sigla*" />
                        </v-col>
                        <v-col cols="12" sm="2">
                            <s-text-field code :error-messages="errors.code" v-model="model.code" label="Código" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-text-field :error="!!errors.description" :error-messages="errors.description" v-model="model.description" label="Descrição"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="10">
                            <s-text-field-icon :error-messages="errors.icon" v-model="model.icon" />
                        </v-col>
                        <v-col cols="12" sm="2">
                            <s-text-field :error-messages="errors.order" v-model="model.order" label="Ordem" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <s-switch text-helper="Exibir como opção na tela de disponibilidade" inset v-model="model.show_availability" label="Disponibilidade"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-switch inset v-model="model.is_default" label="Padrão"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-switch inset v-model="model.active" label="Ativo"/>
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterHourGroup",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                this.error = false;
                this.errors = {};

                if(!this.model.id){
                    this.model.active = true;
                    this.model.show_availability = true;
                    this.model.order = 0;
                }

            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-briefcase-clock"
        },
        title: {
            type: String,
            default: "Grupo de Horário"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        
    },
    methods:{
        ...mapActions('hourGroup', ['ActionUpdateHourGroup', 'ActionCreateHourGroup']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id})

            if(edit) {
                this.ActionUpdateHourGroup(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateHourGroup(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>